import CashMultipleIcon from 'mdi-react/CashMultipleIcon'
import CreditCardIcon from 'mdi-react/CreditCardIcon'
import { useDispatch, useSelector } from 'react-redux'

import { useAppContext } from '@/App.context'
import { getPaymentType, setPaymentType } from '@/ducks/shopOrderReducer'
import { getIsFurthestStep, increaseStep } from '@/ducks/shopProgressReducer'
import { PAYMENT_TYPES } from '@/util/shop'

import './step-payment-options.scss'

const StepPaymentOptions = () => {
  const dispatch = useDispatch()
  const { whiteLabel } = useAppContext()

  const selectedPaymentType = useSelector(getPaymentType)
  const isFurthestStep = useSelector(getIsFurthestStep)
  // @ts-ignore
  const confirmPaymentType = type => {
    dispatch(setPaymentType(type))
    // @ts-ignore
    isFurthestStep && dispatch(increaseStep())
  }

  return (
    <div className={`shop-step__payment-options wl-${whiteLabel}`}>
      <button
        onClick={() => confirmPaymentType(PAYMENT_TYPES.BUY)}
        className={selectedPaymentType === PAYMENT_TYPES.BUY ? 'selected' : ''}
      >
        <span className="icon">
          <CreditCardIcon />
        </span>

        <span className="text">Buying</span>
      </button>

      <button
        onClick={() => confirmPaymentType(PAYMENT_TYPES.LEASE)}
        className={selectedPaymentType === PAYMENT_TYPES.LEASE ? 'selected' : ''}
      >
        <span className="icon">
          <CashMultipleIcon />
        </span>

        <span className="text">Leasing</span>
      </button>
    </div>
  )
}

export default StepPaymentOptions
